module.exports = __webpack_public_path__ + "static/media/shapes.9bf7cb00.svg";